import { getTranslate } from '@/i18n/getTranslate.ts';
import { Trans } from 'react-i18next';
import { TFunction } from 'i18next';
import { Link } from 'ui-kit';
import { envs } from '@/constants';
import React from 'react';
import { errorToast } from '@/components/Toast/Toast.tsx';
import { testId } from '@/utils/testId.ts';
import { DATA_TEST_IDS } from './dataTestIds.ts';

export const contactVivicaSupportToast = async () => {
  const t = await getTranslate('common');
  void errorToast({
    description: (
      <Trans t={t as TFunction} ns={'common'}>
        SOMETHING_WENT_WRONG
        <br />
        PLEASE_TRY_AGAIN_LATER_OR_CONTACT_
        <Link
          color={'secondary'}
          href={envs.CONTACT_SUPPORT_URL}
          data-test-id={testId(DATA_TEST_IDS.toastVivicaSupport)}
        >
          VIVICA_SUPPORT
        </Link>
      </Trans>
    ),
  });
};
